import map from 'lodash/map';
import JSONUtils from 'js/lib/JSONUtils';
import isObject from 'lodash/isObject';
import flat from 'flat';
import keys from 'lodash/keys';

type GenerateInputFormDataDataSetArgs = {
  id: any;
  samples: any;
  isRecordType: any;
};

export function generateInputFormDataFromDataSet(
  inputFormDataDataSetArgs: GenerateInputFormDataDataSetArgs,
) {
  const { id = 0, samples = {}, isRecordType = false } = inputFormDataDataSetArgs;
  let formData: { input?: string; inputAttrs?: string[] };
  const dataSetSamples = map(samples[id].original.out, 'rawMessage');

  if (isRecordType) {
    formData = {
      input: JSONUtils.parseToFormat(dataSetSamples, 'application/json'),
    };
  } else {
    const codeObj = isObject ? dataSetSamples[0] : JSONUtils.parseJson(dataSetSamples[0], true);
    const inputAttrsObj = codeObj ? flat(codeObj, { safe: true }) : null;
    const inputAttrs = inputAttrsObj ? keys(inputAttrsObj) : [];

    formData = {
      inputAttrs,
      input: JSONUtils.parseToFormat(dataSetSamples[0], 'application/json'),
    };
  }

  return formData;
}
